import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {runInAction } from "mobx"
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import type {NewSearchWidgetState} from "../models/new-search-widget.state";

export class NewSearchWidgetSeeAllClickHandler extends ActionHandler {
  state: NewSearchWidgetState;
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSeeAllClick;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    runInAction(() => {
      this.state.selectedListId = params.id;
    })
    if(params?.id !== -1) {
      this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.ANALYTICS.onSeeAllClickEvent, {id: params.id, source: 'search-tool'});
    }
  }
}
